import AuthLayout from "layouts/authLayout/AuthLayout";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Footer, Header } from "stories";
import { FooterChildren, HeaderChildren } from "../auth_views";
import { SignupCard } from "./signupCard/SignupCard";

const Signup = () => {
  return (
    <AuthLayout headerSpacing>
      <Helmet>
        <title>Sign up | Fundever</title>
      </Helmet>
      <Header>
        <HeaderChildren linkedTo={"/sign-in"} />
      </Header>
      <Container fluid>
        <Row>
          <Col md={{ span: 6, offset: 3 }}>
            <SignupCard />
          </Col>
        </Row>
      </Container>
      <Footer>
        <FooterChildren />
      </Footer>
    </AuthLayout>
  );
};

export default Signup;
